export const API_ROUTES = {
    OAUTH_CONFIG: "/oauth-config",
    GRAPHQL: "/v1/assemble/graphql",
    PLAINLY_ADD_TEMPLATES: "/v1/plainly/okta/add-templates",
    RESOURCE_MANAGER: "/v1/resource/okta",
    resourceManagerList: (id: string) => `${API_ROUTES.RESOURCE_MANAGER}/${id}/list?nextToken=false&limit=1000`,
    RESOURCE_MANAGER_REQUEST: "/v1/resource/okta/request",
    PUBLISH_CAMPAIGN: "/v1/publish-campaign/okta",
    publishCampaignAccounts: (campaignId: string) => `${API_ROUTES.PUBLISH_CAMPAIGN}/${campaignId}/accounts`,
    publishCampaignValidate: (campaignId: string) => `${API_ROUTES.PUBLISH_CAMPAIGN}/${campaignId}/validate`,
    publishCampaignSave: (campaignId: string) => `${API_ROUTES.PUBLISH_CAMPAIGN}/${campaignId}/save`,
    PUBLISH_RULES_CAMPAIGNS: "/v1/publish-rules/okta/campaigns",
    publishRulesCampaignsStatus: (campaignId: string) => `${API_ROUTES.PUBLISH_RULES_CAMPAIGNS}/${campaignId}/status`,
    publishRulesCampaignsAccountsUpdates: (campaignId: string, platformAccountId: number) =>
        `${API_ROUTES.PUBLISH_RULES_CAMPAIGNS}/${campaignId}/accounts/${platformAccountId}/updates/`,
    PUBLISH_RULES_DESIRED_STATES: "/v1/publish-rules/okta/build-desired-states",
    PUBLISH_RULES_PLATFORMS_PUBLISH: "/v1/publish-rules/okta/platforms/publish",
    OPENWEATHER_SEARCH_LOCATIONS: "/v1/openweather/okta/search-locations",
    PUBFB_INSTAGRAM_USER: "/v1/pubfb/instagram-user",
    CREATIVEX_DIMENSIONS: "/v1/creativex/dimensions",
    CREATIVEX_SECRETS: "/v1/creativex/secrets",
    JOB: "/v1/job/okta",
    SATALIA_DOMAINS: "/v1/satalia/domains",
    SHARE: "/share"
};
